'use client';

import type { ComponentProps } from 'react';

import { Button } from '@kit/ui/button';
import { cn } from '@kit/ui/utils';

/**
 * The one selected state for booking choices under the sport tabs (booking
 * type, Book For, duration, time). Web outlines and tints it in the brand
 * colour (`variant="selected"`), keeping the solid fill for the pay button;
 * the native theme restyles `data-native-booking-choice` as its sunken fill +
 * matched border.
 */
export function BookingChoiceButton({
  selected,
  className,
  ...props
}: Omit<ComponentProps<typeof Button>, 'variant' | 'aria-pressed'> & {
  selected: boolean;
}) {
  return (
    <Button
      type="button"
      data-native-booking-choice
      aria-pressed={selected}
      variant={selected ? 'selected' : 'outline'}
      // One size for every choice so rows line up across sections; 44px
      // is the touch-target floor (design-system §6).
      className={cn(
        'flex h-11 shrink-0 items-center gap-2 px-4 text-sm font-medium whitespace-nowrap',
        className,
      )}
      {...props}
    />
  );
}
